export const RESIDENT_ROLE_HOUSEHOLDER = 'HOUSEHOLDER';
